import { useQuery } from '@tanstack/react-query'
import { milliseconds } from 'date-fns'

type Risk = {
  description: string
  level: string
  name: string
  score: number
  value: string
}

type RugcheckItem = {
  risks: Risk[] | null
  score: number
  tokenProgram: string
  tokenType: string
}

export const fetchRugcheck = async (mint: string) => {
  try {
    const response = await fetch(
      `https://api.rugcheck.xyz/v1/tokens/${encodeURIComponent(
        mint,
      )}/report/summary`,
    )
    return (await response.json()) as RugcheckItem
  } catch (e) {
    console.error(`failed to fetch rugcheck data for mint: ${mint}`, e)
    throw e
  }
}

export const useRugcheck = (mint: string) => {
  return useQuery({
    queryKey: ['rugcheck-summary', mint],
    queryFn: () => fetchRugcheck(mint),
    cacheTime: milliseconds({ minutes: 15 }),
    staleTime: milliseconds({ minutes: 10 }),
    retry: 3,
    refetchOnWindowFocus: false,
    enabled: !!mint,
  })
}
